<div class="root" *transloco="let t; read:'permit.details.summary'">
    <div *ngIf="summary$ | async as summary">
        <ng-container *ngIf="forModal">
            <div class="root__content">
                <div class="root__content__heading">{{ t("workplace") }}</div>
                <div class="root__content__text">{{ workplace }}</div>
            </div>
            <div class="root__content">
                <div class="root__content__heading">{{ t("id") }}</div>
                <div class="root__content__text">{{ permitId }}</div>
            </div>
            <div class="root__content">
                <div class="root__content__heading">{{ t("permitIssuer") }}</div>
                <ng-container *ngIf="permitIssuer$ | async as issuer">
                    <div class="root__content__text">{{ issuer.firstName + ' ' + issuer.lastName }}</div>
                </ng-container>
            </div>
        </ng-container>

        <div *ngIf="summary.startDate" class="root__content">
            <ng-container *ngIf="permit$ | async as permit">
                <div *ngIf="permit.isFlammableHotWork" class="root__content__heading">{{ t("validTime") }}</div>
                <div *ngIf="!permit.isFlammableHotWork" class="root__content__heading">{{ t("validTimeNotHotWork") }}</div>
            </ng-container>
            <div class="root__content__text">
                <div class="root__content__text__start-date">
                    {{ summary.startDate | haDate: "dateTimeStandard" }}
                </div>
                <div *ngIf="summary.endDate" class="root__content__text__closed-date">
                    {{ summary.endDate | haDate: "timeIfSameDayElseFullDate":summary.startDate }}
                </div>
                <div *ngIf="canComplete(currentUserRoles$ | async) && currentStep$ | async as currentStep" class="root__content__text__link" (click)="setPermitEnd()">
                    <div *ngIf="currentStep.step === PermitStep.started || currentStep.step === PermitStep.expiredNotSigned">
                        {{ t("writeOffPermit") }}
                    </div>
                </div>
                <div *ngIf="summary.premium && workplaceDetails$ | async as premiumPermitSetting" class="root__content__update-box">
                    <ng-container *ngIf="permit$ | async as permitSetting">
                        <button *ngIf="canExtend(currentUserRoles$ | async) && (premiumPermitSetting.permitDuration - permitSetting.validityPeriod > 0) && (summary.closedDate === null && !summary.closedBySystem)" class="root__content__update-button" (click)="openValidityPeriodModal()">{{ t("updateValidity") }}</button>

                    </ng-container>
                </div>
            </div>
        </div>

        <div *ngIf="(summary.permitDurationComment !== null && summary.permitDurationComment.length > 0)" class="root__content">
            <div class="root__content__heading">{{ t("permitDurationComment") }}</div>
            <div class="root__content__text">{{summary.permitDurationComment}}</div>
        </div>

        <div class="root__content" *ngIf="(currentStep$ | async).step >= PermitStep.ended">
            <div class="root__content__heading">{{ t("closedByAndDate") }}</div>
            <div class="root__content__text">
                <ng-container *ngIf="!summary.closedBySystem && permitIssuer$ | async as issuer">
                    {{ issuer.firstName + ' ' + issuer.lastName }}
                </ng-container>
                <ng-container *ngIf="summary.closedBySystem">
                    {{ t("closedBySystem") }}
                </ng-container>
                {{ summary.closedDate | haDate: "dateTimeStandard" }}
            </div>
        </div>

        <div class="root__content">
            <div class="root__content__heading">{{ t("workMethods") }}</div>
            <div class="root__content__text">{{ getTranslatedWorkMethodText(summary.workMethods, summary.workMethodManualInput) }}</div>
        </div>

        <ng-container *ngIf="permit$ | async as permit">
            <div class="root__content" *ngIf="permit.hasDisabledFireAlarm === true">
                <div class="root__content__heading">{{ t("disabledFireAlarm") }}</div>
                <div class="root__content__text">{{ summary.disabledFireAlarm }}</div>
            </div>
        </ng-container>

        <div class="root__content" *ngIf="summary.operationManager">
            <div class="root__content__heading">{{ t("operationManager") }}</div>
            <div class="root__content__text">{{ summary.operationManager }}</div>
        </div>

        <div class="root__content" *ngIf="summary.superintendentName">
            <div class="root__content__heading">{{ t("superIntendent") }}</div>
            <div class="root__content__text">{{ summary.superintendentName }}</div>
        </div>

        <ng-container *ngIf="permit$ | async as permit">
            <div class="root__content" *ngIf="permit.isFlammableHotWork">
                <div class="root__content__heading">{{ t("postWorkMonitoringTime") }}</div>
                <div class="root__content__text">{{ summary.postWorkMonitoringTime }} min</div>
            </div>
        </ng-container>

        <div class="root__atex-documents" *ngIf="permit$ | async as permit">
            <div class="root__atex-documents__row" *ngIf="hasFlammableAtexContext(permit)">
                <div class="root__content__heading">{{ t("flammableAtexPermitHeading") }}</div>
                <div class="root__content__open-modal" (click)="openFlammableAtexPermitModal()">{{ t("viewFlammableAtexPermit") }}</div>
            </div>

            <div class="root__atex-documents__row" *ngIf="showGasFreeDeclaration(permit)">
                <div class="root__content__heading">{{ t("gasFreeDeclarationHeading") }}</div>
                <div class="root__content__open-modal" (click)="openGasFreeDeclarationModal()">{{ t("viewGasFreeDeclaration") }}</div>
            </div>
        </div>

        <div class="root__content">
            <div class="root__content__heading">{{ t("checkpointsHeading") }}</div>
            <div class="root__content__open-modal" (click)="openPermitCheckpointsModal()">
                {{ t("openCheckpointsModal") }}
            </div>
        </div>
    </div>
</div>
